'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024 from "./com.raquo.airstream.ownership.-Dynamic-Subscription$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_KeyUpdater(key, values, update) {
  this.GW = null;
  this.GY = null;
  this.GX = null;
  this.GW = key;
  this.GY = values;
  this.GX = update;
}
export { $c_Lcom_raquo_laminar_modifiers_KeyUpdater as $c_Lcom_raquo_laminar_modifiers_KeyUpdater };
$p = $c_Lcom_raquo_laminar_modifiers_KeyUpdater.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_KeyUpdater;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_KeyUpdater() {
}
export { $h_Lcom_raquo_laminar_modifiers_KeyUpdater as $h_Lcom_raquo_laminar_modifiers_KeyUpdater };
$h_Lcom_raquo_laminar_modifiers_KeyUpdater.prototype = $p;
$p.dL = (function(element) {
  this.u1(element);
});
$p.u1 = (function(element) {
  element.Wt(this.GW);
  var observable = this.GY;
  var onNext = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((value) => {
    this.GX.jj(element, value, this);
  }));
  return $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().XR(element.fs, observable, onNext);
});
var $d_Lcom_raquo_laminar_modifiers_KeyUpdater = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_KeyUpdater, "com.raquo.laminar.modifiers.KeyUpdater", ({
  iv: 1,
  ab: 1,
  c6: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_KeyUpdater as $d_Lcom_raquo_laminar_modifiers_KeyUpdater };
